<template>
  <div class="content-box">
    <div class="element-box">
      <h5 class="form-header">Lista de Cortes de Tienda</h5>

    </div>
    <div class="row">
      <div class="col-6" v-for="tienda in data.results" :key="tienda.codigo" >
        <div class="element-box" :class="{ '': (!tienda.tienda_aperturada) }">
          <h5 class="form-header">
            {{ tienda.codigo }} - {{ tienda.nombre }}
          </h5>
          <div class="form-desc" v-if="tienda.apertura_actual">
            <ul>
              <li>
                Total Resumen: <b> Q {{ tienda.apertura_actual.total_resumen_cortes }}</b>
              </li>
              <li>
                Total Detalle: <b> Q {{ tienda.apertura_actual.total_detalle }}</b>
              </li>
              <li>
                Fecha Apertura: <b>{{ tienda.apertura_actual.fecha_apertura }}</b>
              </li>
            </ul>
            <div class="alert"
            v-if="tienda.apertura_actual"
              :class="{ 'alert-warning': !tienda.tienda_aperturada, 'alert-success': tienda.tienda_aperturada }"
              role="alert">
              <span v-if="tienda.tienda_aperturada == true"><strong>Abierta! </strong> 
                La tienda se encuentra operando
                <strong v-if="tienda.apertura_actual.estado == 'B'">Tienda cerrada, pero sin finalizar</strong>
              </span>
              <span v-if="tienda.tienda_aperturada == false "><strong>Cerrada! </strong> La tienda se encuentra cerrada</span>
            </div>

          </div>
          <div class="element-box-content text-center">
            <button class="mr-2 mb-2 btn btn-primary" :disabled="tienda.tienda_aperturada" type="button"
              @click="aperturarTienda(tienda, 'mario.solis', 'premier123')">
              Aperturar Tienda</button>
            <!--button class="mr-2 mb-2 btn btn-outline-secondary" :disabled="!tienda.tienda_aperturada" type="button">
              Cerrar Tienda</button-->
            <router-link class="mr-2 mb-2 btn btn-info" v-if="tienda.tienda_aperturada"
              :to="{ name: 'cxc-corte-tienda-editar', params: { id: tienda.apertura_actual.id } }">
              Ver Detalle
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import _ from "lodash";

import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
  },
  data() {
    return {
      data: {
        results: []
      },
    };
  },
  computed: {
  },
  mounted() {
    let self = this;
    this.clearFilterData();
    self.refreshData();
  },
  methods: {
    filterData() {
      this.convertFormatDate();
      this.refreshData({
        page: 1,
      });
    },
    clearFilterData() {
      this.refreshData({
        page: 1,
      });
    },
    hide: function () {
    },
    onRefreshData() { },
    refreshData(params) {
      let self = this;
      DynamicService.fetch("cat", "tiendas", params).then((response) => {
        console.log(response.data);
        self.data = response.data;
      }
      );
    },
    aperturarTienda(tienda, usuario, clave) {
      let self = this;
      DynamicService.postActionList(
        "cxc",
        "corte-caja-tienda",
        'aperturar_tienda',
        {
          usuario: usuario,
          clave: clave,
          tienda: tienda.codigo
        }
      ).then((response) => {
        self.refreshData();
      });
    },
    showModalEdit() { },
  },
};
</script>
